import {onDomReady} from '../lib/on_dom_ready';

onDomReady(() => {
  const form = document.querySelector('form[data-csrf-refresh-url]');
  if (!form) return;

  let refreshing = false;
  let readyToSubmit = false;

  form.addEventListener('submit', async (event) => {
    if (readyToSubmit) return;

    event.preventDefault();
    if (refreshing) return;

    refreshing = true;

    try {
      const response = await fetch(form.dataset.csrfRefreshUrl, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {Accept: 'application/json'}
      });

      if (!response.ok) throw new Error('CSRF refresh failed');

      const {authenticity_token: token} = await response.json();
      if (!token) throw new Error('CSRF token missing');

      form.elements.authenticity_token.value = token;
    } catch (error) {
      console.error(error);
      refreshing = false;
      return;
    }

    readyToSubmit = true;

    if (event.submitter) {
      form.requestSubmit(event.submitter);
    } else {
      form.requestSubmit();
    }
  });
});
